<mat-card *ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCopy)" class="padding-0-5 primary-text">
	<mat-card-content>
		<div class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem">
			<div fxFlex="25" fxLayoutAlign="start center">
				<mat-form-field class="custom-form-field" fxFlex="100">
					<input
						[(ngModel)]="projectCopy.name"
						autocomplete="off"
						floatLabel="never"
						fxFlex
						matInput
					/>
				</mat-form-field>
			</div>
			<div fxFlex="25">
				<div class="fw-700" fxFlex fxLayoutAlign="start center">Origin:</div>
				<div fxFlex fxLayoutAlign="start center">
					{{
						projectCopy.originCity && projectCopy.originState
							? projectCopy.originCity + ',' + projectCopy.originState
							: ''
					}}
				</div>
			</div>
			<div fxFlex="25">
				<div class="fw-700" fxFlex fxLayoutAlign="start center">Destination:</div>
				<div fxFlex fxLayoutAlign="start center">
					{{
						projectCopy.destCity && projectCopy.destState
							? projectCopy.destCity + ',' + projectCopy.destState
							: ''
					}}
				</div>
			</div>
			<div fxFlex="25" fxLayoutAlign="end center">
				<div fxFlex fxLayoutAlign="start center" class="fw-700">Equipment:</div>
				<div fxFlex fxLayoutAlign="start center" class="trailer_type_container">
					<mat-form-field class="custom-form-field full-width" floatLabel="never">
						<mat-select [(ngModel)]="projectEquipments" multiple>
							<mat-option *ngFor="let trailer of trailerTypes" [value]="trailer.dbVal">
								{{ trailer.value }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
			</div>
		</div>
		<div class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem">
			<div
				*ngIf="
					IS_NOT_NULL_OR_UNDEFINED(usersList) &&
					(IS_NOT_NULL_OR_UNDEFINED(projectCopy.customerDTO) || IS_EMPTY(projectCopy.revenueCode))
				"
				fxFlex="25"
				fxLayoutAlign="start center"
			>
				<app-customer-popover
					*ngIf="accountSettings.ROLE_BASED_CUSTOMER_DATA_ACCESS"
					(setCustomer)="setCustomer($event)"
					[customerSelected]="projectCopy.customerDTO"
					fxFlex
				></app-customer-popover>
			</div>
			<div
				*ngIf="
					IS_NOT_EMPTY(projectCopy.revenueCode) && IS_NULL_OR_UNDEFINED(projectCopy.customerDTO)
				"
				fxFlex="25"
				fxLayoutAlign="start center"
			>
				<div class="fw-700" fxFlex fxLayoutAlign="start center">Revenue Code:</div>
				<div fxFlex fxLayoutAlign="end center">
					<mat-form-field class="custom-form-field" fxFlexFill>
						<input [(ngModel)]="projectCopy.revenueCode" autocomplete="off" fxFlex matInput />
					</mat-form-field>
				</div>
			</div>
			<div fxFlex="25">
				<div fxFlex>
					<app-user-popover
						(userChanged)="assigneeUpdated($event)"
						[isEnabled]="userPopoverComponent.enabled"
						[placeholder]="userPopoverComponent.placeholder"
						[selectedUsers]="userPopoverComponent.selectedUsers"
						[singleselect]="true"
						[usersList]="usersList"
						fxFlex
					>
					</app-user-popover>
				</div>
			</div>
			<div fxFlex="25">
				<div class="fw-700" fxFlex fxLayoutAlign="start center">Due Date:</div>
				<div fxFlex fxLayoutAlign="start center">
					<mat-form-field class="custom-form-field" floatLabel="never">
						<input
							(click)="picker.open()"
							(dateChange)="dueDateUpdated()"
							[formControl]="dueDate"
							[matDatepicker]="picker"
							[min]="minimumDueDate"
							matInput
							placeholder="Due Date"
						/>
						<mat-datepicker-toggle [for]="picker" matSuffix tabIndex="-1"></mat-datepicker-toggle>
						<mat-datepicker #picker></mat-datepicker>
					</mat-form-field>
				</div>
			</div>
			<div fxFlex="25">
				<div class="fw-700" fxFlex fxLayoutAlign="start center">Stage:</div>
				<div fxFlex fxLayoutAlign="start center">
					<mat-form-field class="custom-form-field" floatLabel="never" fxFlex="100">
						<mat-select [(ngModel)]="projectCopy.stageId" disableOptionCentering>
							<mat-option *ngFor="let stage of PROJECT_STAGES" [value]="stage.type">
								{{ stage.label }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
			</div>
		</div>
		<div class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem">
			<div fxFlex="25">
				<div class="fw-700" fxFlex fxLayoutAlign="start center">Load Volume:</div>
				<div fxFlex fxLayoutAlign="start center">
					<mat-form-field class="custom-form-field" floatLabel="never" fxFlex>
						<mat-select [(ngModel)]="projectCopy.loadVolumeDuration" disableOptionCentering>
							<mat-option>Select</mat-option>
							<mat-option *ngFor="let duration of loadVolumeDuration" [value]="duration">
								{{ duration }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
			</div>
			<div fxFlex="25" fxLayoutAlign="start center">
				<div class="fw-700" fxFlex fxLayoutAlign="start center">Load Count:</div>
				<div fxFlex fxLayoutAlign="end center">
					<mat-form-field class="custom-form-field" fxFlexFill>
						<input [(ngModel)]="projectCopy.loadVolume" autocomplete="off" fxFlex matInput />
					</mat-form-field>
				</div>
			</div>
			<div fxFlex="25">
				<div class="fw-700" fxFlex fxLayoutAlign="start center">Available Loads:</div>
				<div fxFlex fxLayoutAlign="end end">
					<mat-form-field class="custom-form-field">
						<input
							[(ngModel)]="projectCopy.loadCount"
							autocomplete="off"
							floatLabel="never"
							mask="separator"
							thousandSeparator=","
							matInput
						/>
					</mat-form-field>
				</div>
			</div>
			<div fxFlex="25">
				<div class="fw-700" fxFlex fxLayoutAlign="start center">Max Capacity:</div>
				<div fxFlex fxLayoutAlign="start center">-</div>
			</div>
		</div>
		<div class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem">
			<div fxFlex="25" fxLayoutAlign="start center">
				<div class="fw-700" fxFlex fxLayoutAlign="start center">Max Buy:</div>
				<div fxFlex fxLayoutAlign="end center">
					<mat-form-field class="custom-form-field" fxFlexFill>
						<mat-icon class="primary-light-color vertical-align-bottom" matPrefix
							>attach_money
						</mat-icon>
						<input
							[(ngModel)]="projectCopy.maxBuy"
							autocomplete="off"
							floatLabel="never"
							fxFlex
							mask="separator"
							thousandSeparator=","
							matInput
						/>
					</mat-form-field>
				</div>
			</div>
			<div (click)="submitLastBid()" class="cursor-pointer" fxFlex="25">
				<div class="fw-700" fxFlex fxLayoutAlign="start center">Last Bid:</div>
				<div class="font-size-14 underline" fxFlex fxLayoutAlign="end center">
					<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCopy.lastBid)">
						{{ projectCopy.lastBid / 100 | currency: 'USD' : 'symbol' : '1.0-0' }}
					</span>
					<span
						*ngIf="IS_NULL_OR_UNDEFINED(projectCopy.lastBid)"
						class="font-size-14"
						fxLayoutAlign="center center"
					>
						<mat-icon
							[inline]="true"
							[matTooltip]="TOOLTIP_MSG.LAST_BID"
							class="primary-text w-inherit"
							matSuffix
							matTooltipClass="custom-tooltip"
						>
							info
						</mat-icon>
					</span>
				</div>
			</div>
			<div fxFlex="25">
				<div class="fw-700" fxFlex fxLayoutAlign="start center">Best Rate:</div>
				<div fxFlex fxLayoutAlign="end center">
					<span *ngIf="IS_NOT_NULL_OR_UNDEFINED(projectCopy.bestRate)">
						{{ projectCopy.bestRate / 100 | currency: 'USD' : 'symbol' : '1.0-2' }}
					</span>
					<span
						*ngIf="IS_NULL_OR_UNDEFINED(projectCopy.bestRate)"
						class="font-size-14"
						fxLayoutAlign="center center"
					>
						<mat-icon
							[inline]="true"
							[matTooltip]="TOOLTIP_MSG.BEST_RATE"
							class="primary-text w-inherit"
							matSuffix
							matTooltipClass="custom-tooltip"
						>
							info
						</mat-icon>
					</span>
				</div>
			</div>
			<div fxFlex="25"></div>
		</div>
		<div class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem">
			<div fxFlex="25" fxLayoutAlign="start center">
				<div class="fw-700" fxFlex fxLayoutAlign="start center">Commodity:</div>
				<div fxFlex fxLayoutAlign="end center">
					<mat-form-field class="custom-form-field" fxFlexFill>
						<input
							[(ngModel)]="projectCopy.commodity"
							autocomplete="off"
							floatLabel="never"
							fxFlex
							matInput
						/>
					</mat-form-field>
				</div>
			</div>
			<div fxFlex="25">
				<div class="fw-700" fxFlex fxLayoutAlign="start center">Weight:</div>
				<div fxFlex fxLayoutAlign="end center">
					<mat-form-field class="custom-form-field" fxFlexFill>
						<input
							[(ngModel)]="projectCopy.weight"
							autocomplete="off"
							floatLabel="never"
							fxFlex
							matInput
						/>
						<span matSuffix>lbs</span>
					</mat-form-field>
				</div>
			</div>
			<div *ngIf="accountSettings.PROJECT_GROUPS_ENABLED" fxFlex="25">
				<div fxFlex fxLayoutAlign="start center" class="fw-700">Project Type:</div>
				<div fxFlex fxLayoutAlign="start center" class="project_type_container">
					<mat-form-field class="custom-form-field full-width" floatLabel="never">
						<mat-select [(ngModel)]="projectCopy.type">
							<mat-option
								*ngFor="let projectType of projectTypes | keyvalue"
								[value]="projectType.value.value"
							>
								{{ projectType.value.label }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
			</div>
			<div fxFlex="25"></div>
		</div>
		<div class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem">
			<div fxFlex="25" fxLayoutAlign="end center" class="fw-700">
				<mat-checkbox
					*ngIf="
						accountSettings.PROJECT_GROUPS_ENABLED &&
						projectCopy.type == PROJECT_TYPES.WATERFALL.value
					"
					[(ngModel)]="projectCopy.inviteUngroupedCarriers"
					(ngModelChange)="sendOfferSettingUpdated($event, 'ungroupedCarriersDelay')"
					[labelPosition]="'before'"
					color="primary"
					class="fn-size-13"
				>
					Send to Network Carriers in
					<mat-form-field
						class="custom-form-field ungrouped-carriers-delay"
						fxFlex="12"
						appearance="standard"
					>
						<input
							[(ngModel)]="projectCopy.ungroupedCarriersDelay"
							autocomplete="off"
							floatLabel="never"
							fxFlex
							matInput
							[disabled]="!projectCopy.inviteUngroupedCarriers"
						/>
					</mat-form-field>
					min
				</mat-checkbox>
			</div>
			<div fxFlex="25" fxLayoutAlign="start center" class="fw-700 out-of-network-field">
				<mat-checkbox
					*ngIf="
						isWaterfallOrDedicatedLaneProject && accountSettings.ENABLE_OUT_OF_NETWORK_CARRIERS
					"
					[(ngModel)]="projectCopy.sendToOutOfNetworkCarriers"
					(ngModelChange)="sendOfferSettingUpdated($event, 'sendToOutOfNetworkCarriersDelay')"
					[labelPosition]="'before'"
					[disabled]="!baConfigService.OUT_OF_NETWORK_ENABLED"
					color="primary"
					class="fn-size-13"
				>
					Send Out of Network Offers in
					<mat-form-field
						class="custom-form-field ungrouped-carriers-delay"
						fxFlex="12"
						appearance="standard"
					>
						<input
							[(ngModel)]="projectCopy.sendToOutOfNetworkCarriersDelay"
							autocomplete="off"
							floatLabel="never"
							fxFlex
							matInput
							[disabled]="!baConfigService.OUT_OF_NETWORK_ENABLED"
						/>
					</mat-form-field>
					min
				</mat-checkbox>
			</div>
			<div *ngIf="!accountSettings.PROJECT_GROUPS_ENABLED" fxFlex="50" fxLayoutAlign="start center">
				<div *ngIf="additionalNotes.length > 0" class="additional-notes-summary">
					{{ additionalNotes.join(', ') }}
				</div>
			</div>
			<div fxFlex="25" fxLayoutAlign="start center">
				<div
					(click)="showNotes = !showNotes"
					[fxFlex]="IS_TEAMS_CAPACITY_ENABLED ? 50 : 100"
					[fxLayoutAlign]="IS_TEAMS_CAPACITY_ENABLED ? 'start center' : 'end center'"
					class="primary-text cursor-pointer"
				>
					<span>Edit Notes</span>
					<mat-icon *ngIf="!showNotes" class="vertical-align-middle">keyboard_arrow_down</mat-icon>
					<mat-icon *ngIf="showNotes" class="vertical-align-middle">keyboard_arrow_up</mat-icon>
				</div>
				<div *ngIf="IS_TEAMS_CAPACITY_ENABLED" fxFlex="50" fxLayoutAlign="center center">
					<mat-checkbox
						[(ngModel)]="projectCopy.requireTeams"
						[labelPosition]="'before'"
						color="primary"
					>
						Require Teams
					</mat-checkbox>
				</div>
			</div>
			<div fxFlex="25" fxLayoutAlign="end center">
				<button
					(click)="updateProject()"
					*ngIf="!isUpdatingProject"
					[disabled]="isUpdatingProject || !isProjectUpdated()"
					color="primary"
					fxFlex="100"
					mat-raised-button
				>
					UPDATE
				</button>
				<div
					*ngIf="isUpdatingProject"
					class="h-100"
					fxLayout="row"
					fxLayoutAlign="space-around center"
				>
					<mat-spinner [diameter]="30"></mat-spinner>
				</div>
			</div>
		</div>

		<div *ngIf="showNotes" class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem">
			<div class="fw-700" fxFlex="21.5" fxLayoutAlign="start center">Packaging:</div>
			<div fxFlex fxLayoutAlign="start center">
				<app-special-instructions-dialog
					(updatedString)="projectCopy.packaging = $event; inputChanged('packaging')"
					[displaySecondaryButton]="true"
					[isEditable]="true"
					[layoutAlign]="'star center'"
					[specialInstructions]="projectCopy.packaging"
					fxFlex
					modalTitle="Packaging"
					primaryButtonText="Update"
				>
				</app-special-instructions-dialog>
			</div>
		</div>
		<div *ngIf="showNotes" class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem">
			<div class="fw-700" fxFlex="21.5" fxLayoutAlign="start center">Trailer Requirements:</div>
			<div fxFlex fxLayoutAlign="start center">
				<app-special-instructions-dialog
					(updatedString)="
						projectCopy.trailerRequirements = $event; inputChanged('trailerRequirements')
					"
					[displaySecondaryButton]="true"
					[isEditable]="true"
					[layoutAlign]="'star center'"
					[specialInstructions]="projectCopy.trailerRequirements"
					fxFlex
					modalTitle="Trailer Requirements"
					primaryButtonText="Update"
				>
				</app-special-instructions-dialog>
			</div>
		</div>
		<div *ngIf="showNotes" class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem">
			<div class="fw-700" fxFlex="21.5" fxLayoutAlign="start center">Shipper Notes:</div>
			<div fxFlex fxLayoutAlign="start center">
				<app-special-instructions-dialog
					(updatedString)="projectCopy.shipperNotes = $event; inputChanged('shipperNotes')"
					[displaySecondaryButton]="true"
					[isEditable]="true"
					[layoutAlign]="'star center'"
					[specialInstructions]="projectCopy.shipperNotes"
					fxFlex
					modalTitle="Shipper Notes"
					primaryButtonText="Update"
				>
				</app-special-instructions-dialog>
			</div>
		</div>
		<div *ngIf="showNotes" class="font-size-14 p-0-3" fxLayout="row" fxLayoutGap="1.5rem">
			<div class="fw-700" fxFlex="21.5" fxLayoutAlign="start center">Receiver Notes:</div>
			<div fxFlex fxLayoutAlign="start center">
				<app-special-instructions-dialog
					(updatedString)="projectCopy.receiverNotes = $event; inputChanged('receiverNotes')"
					[displaySecondaryButton]="true"
					[isEditable]="true"
					[layoutAlign]="'star center'"
					[specialInstructions]="projectCopy.receiverNotes"
					fxFlex
					modalTitle="Receiver Notes"
					primaryButtonText="Update"
				>
				</app-special-instructions-dialog>
			</div>
		</div>
	</mat-card-content>
</mat-card>
